import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import { AtnDsPageHeaderStore } from '../../page-header.store'

/** Renders page-header breadcrumbs with router-backed navigation links. */
@ngCore.Component({
  // TODO: why?
  changeDetection: ngCore.ChangeDetectionStrategy.OnPush,
  imports: [ngRouter.RouterLink],
  selector: 'atn-ds-page-header-breadcrumbs',
  standalone: true,
  styleUrls: ['./page-header-breadcrumbs.component.scss'],
  templateUrl: './page-header-breadcrumbs.component.html',
})
export class AtnDsPageHeaderBreadcrumbsComponent {
  /** Local page-header store containing the raw breadcrumb input. */
  public readonly store = ngCore.inject(AtnDsPageHeaderStore)

  /** Angular Router is used to clone UrlTrees before template binding. */
  private readonly _router = ngCore.inject(ngRouter.Router)

  /**
   * Breadcrumbs prepared for RouterLink.
   *
   * RouterLink mutates UrlTree segment groups while recognizing routes.
   * Breadcrumb UrlTrees can come from frozen store state, so they are cloned
   * before being handed to RouterLink.
   */
  public readonly breadcrumbsSg = ngCore.computed(() =>
    this.store.breadcrumbsSg()?.map(breadcrumb => ({
      ...breadcrumb,
      url: breadcrumb.url
        ? this._router.parseUrl(this._router.serializeUrl(breadcrumb.url))
        : undefined,
    })),
  )
}
